import Pikaday, {PikadayI18nConfig} from 'pikaday';

export const DATE_FORMAT = 'DD.MM.YYYY';

export default class DatePicker {
    public constructor(element: Element) {
        const datepicker = new Pikaday({
            field: element as HTMLElement,
            firstDay: 1,
            format: DATE_FORMAT,
            i18n,
        });
    }
}

export const i18n: PikadayI18nConfig = {
    previousMonth: 'Předchozí měsíc',
    nextMonth: 'Následující měsíc',
    months: [
        'Leden',
        'Únor',
        'Březen',
        'Duben',
        'Květen',
        'Červen',
        'Červenec',
        'Srpen',
        'Září',
        'Říjen',
        'Listopad',
        'Prosinec',
    ],
    weekdays: [
        'Neděle',
        'Pondělí',
        'Úterý',
        'Středa',
        'Čtvrtek',
        'Pátek',
        'Sobota',
    ],
    weekdaysShort : [
        'Ne',
        'Po',
        'Út',
        'St',
        'Čt',
        'Pá',
        'So',
    ],
};
